<div class="header">
  <div class="title">{{title | trans}}</div>
  <button type="button" (click)="closed.emit()" mat-icon-button>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<div class="body"><ng-content></ng-content></div>
